import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      position: 'relative',

      '&$loading': {
        '& $label': {
          color: 'transparent',
        },
      },
    },
    loading: {},
    label: {},
    spinner: {
      position: 'absolute',
    },
    round: {
      borderRadius: 50,
      padding: theme.spacing(1, 2.5),
    },
    whiteColor: {
      color: COLORS.neutral.white,
      borderColor: COLORS.neutral.white,
    },
    grayColor: {
      color: COLORS.primary.default,
      backgroundColor: COLORS.gray.gray90,
    },
    noHover: {
      '&:hover': {
        backgroundColor: 'inherit',
      },
    },
  }),
  { name: 'Button' }
);
